import axios from 'axios';

const { origin } = window.location;

const baseURL = process.env.NODE_ENV === 'production' ?  `${origin}/api` : 'https://dev.tracknme.com.br/api'

const apiUpload = axios.create({
    baseURL,
    headers: {
        'Content-Type' : 'application/json'
    }
});

apiUpload.interceptors.request.use(async config => {
    if (config.method === 'get') {
        
    }
    return config;
})

export default apiUpload;